"use strict";

exports.__esModule = true;
exports.UserList = UserList;
var _react = _interopRequireDefault(require("react"));
var _ListView = require("../../Core/ListView");
var _UserListItem = require("./UserListItem");
var _excluded = ["values"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function UserList(_ref) {
  var values = _ref.values,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_ListView.ListView, extra, values.map(function (value) {
    return /*#__PURE__*/_react["default"].createElement(_UserListItem.UserListItem, {
      key: value.id,
      value: value
    });
  }));
}